import React, { useState } from 'react'

/**
 * Champs partagés pour manipuler un switch via le registre de switches
 * (experience.switchRegistry). L'utilisateur choisit une clé (et une valeur)
 * déclarée dans une liste ; ce qui est affiché est exactement ce qui est écrit
 * en JSON. Une option « personnalisée » permet de saisir n'importe quelle valeur.
 */

const CUSTOM = '__custom__'

/** Sélecteur de clé de switch : liste des switches nommés + échappatoire personnalisée. */
export const SwitchKeySelect = ({ registry = [], value = '', onChange, label = 'clé' }) => {
  const known = registry.find(entry => entry.key === value)
  const isUnknownValue = !!value && !known
  // "forceCustom" mémorise un choix explicite « clé personnalisée » (même sans valeur saisie).
  const [forceCustom, setForceCustom] = useState(false)
  const customMode = forceCustom || isUnknownValue

  return (
    <div className="form-group field field-string">
      <label className="control-label">{label}</label>
      <select
        className="form-control"
        value={customMode ? CUSTOM : value || ''}
        onChange={event => {
          const next = event.target.value
          if (next === CUSTOM) {
            setForceCustom(true)
          } else {
            setForceCustom(false)
            onChange(next)
          }
        }}
      >
        <option value="" />
        {registry.map(entry => (
          <option key={entry._id || entry.key} value={entry.key}>
            {entry.key}
          </option>
        ))}
        <option value={CUSTOM}>✏️ Clé personnalisée…</option>
      </select>
      {customMode && (
        <input
          type="text"
          className="form-control"
          placeholder="clé réelle enregistrée en JSON"
          value={value}
          onChange={event => onChange(event.target.value)}
          style={{ marginTop: 6 }}
        />
      )}
    </div>
  )
}

/** Champ de valeur d'un switch, dont le type d'entrée suit celui du switch nommé. */
export const SwitchValueField = ({ registry = [], switchKey = '', value = '', onChange, label = 'valeur' }) => {
  const entry = registry.find(e => e.key === switchKey)
  const type = entry?.type
  const enumValues = type === 'enum' ? entry.values || [] : []
  const knownEnum = enumValues.includes(value)
  const isUnknownValue = !!value && !knownEnum
  const [forceCustom, setForceCustom] = useState(false)

  if (type === 'enum' && enumValues.length) {
    const customMode = forceCustom || isUnknownValue
    return (
      <div className="form-group field field-string">
        <label className="control-label">{label}</label>
        <select
          className="form-control"
          value={customMode ? CUSTOM : value || ''}
          onChange={event => {
            const next = event.target.value
            if (next === CUSTOM) setForceCustom(true)
            else {
              setForceCustom(false)
              onChange(next)
            }
          }}
        >
          <option value="" />
          {enumValues.map(v => (
            <option key={v} value={v}>
              {v}
            </option>
          ))}
          <option value={CUSTOM}>✏️ Valeur personnalisée…</option>
        </select>
        {customMode && (
          <input
            type="text"
            className="form-control"
            placeholder="valeur personnalisée"
            value={value}
            onChange={event => onChange(event.target.value)}
            style={{ marginTop: 6 }}
          />
        )}
      </div>
    )
  }

  return (
    <div className="form-group field field-string">
      <label className="control-label">{label}</label>
      <input
        type={type === 'number' ? 'number' : 'text'}
        className="form-control"
        value={value}
        onChange={event => onChange(event.target.value)}
      />
    </div>
  )
}
